export default __webpack_public_path__ + "static/media/Hand.add66822.svg";